import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input, Button, Modal} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import CheckIcon from '@mui/icons-material/Check';
import { ExclamationCircleFilled } from '@ant-design/icons';

import axios from '../apiClient';
import Alert from '../alert';
import moment from 'moment/moment';
import Loader from '../loader';

const {RangePicker} = DatePicker;

export default function MasterCommissions() {

  const [page,setPage] = useState(1);
  const [commissions, setCommissions] = useState([]);
  const [total,setTotal] = useState();
  const [totalAmount,setTotalAmount ] = useState(0);
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const location = useLocation();
  const {id: masterId} = location.state;
  const didMount = useRef(false);
  const startOfDay = moment().subtract(30,'day').format('YYYY-MM-DD HH:mm:ss');
  const endOfTmr = moment().add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
  const [date,setDate] = useState({startDate: startOfDay,endDate: endOfTmr})
  const navigate = useNavigate()

  async function fetchData() {
    setLoading(true)
    let res = await axios.get(`/owner/getCommissionListByMasterId?masterId=${masterId}&startDate=${date.startDate}&endDate=${date.endDate}&current=${page}&pageSize=10`)
    if (res.code != 200) {
        if(res.code == 404){
            setLoading(false);
            setCommissions([]);
            setTotal(0)
            setTotalAmount(0)
            return
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setCommissions(res.data?.commission)
    setTotal(res.data.pagination.total)
    setTotalAmount(Number(res.data.totalCommissionAmount).toLocaleString())
    setLoading(false)
  }


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page)

  const handleDateChange = async (v,dateString) => setDate({startDate: dateString[0],endDate: dateString[1]});

  const handlePay = async () => {
    setLoading(true);
    const res = await axios.post(`/bet/setMasterCommission`,{masterId})
    setErrorMsg({ code: res.code, msg: res.message })
    setOpenAlert(true)
    fetchData();
  }

  useEffect(()=> {
      fetchData()
  },[page,date])

  const columns = [
      {
        title: 'Slip Id',
        dataIndex: 'short_id',
        key: 'short_id',
      },
      {
        title: 'Slip Result',
        key: 'slip_result',
        dataIndex: 'slip_result',
      },
      {
        title: 'Bet Type',
        key: 'bet_type',
        dataIndex: 'bet_type',
      },
      {
        title: 'Commission',
        key: 'master_commission_amount',
        dataIndex: 'master_commission_amount',
        render : (amount) => Number(amount).toLocaleString()
      },
      {
        title: 'Complete',
        key: 'completed',
        dataIndex: 'completed',
        render: (completed) => completed == 1? <CheckIcon style={{color: "green"}}/> : "-"
      },
      {
        title: 'Popular',
        key: 'popular',
        dataIndex: 'popular',
        render: (popular) => popular == 1? "B" : "S"
      },
      {
        title: 'Date',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
      }
      
  ];

  const { confirm } = Modal;
  const showConfirm = () => {
    confirm({
      mask: false,
      centered: true,
      maskClosable: true, 
      title: 'Are you sure to pay commission?',
      icon: <ExclamationCircleFilled />,
      content: '',
      onOk() {
        handlePay()
      },
    });
  };

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div style={{display: 'flex',justifyContent: "space-between"}}>
        <div style={{display: 'flex',alignItems: 'center'}}>
          <RangePicker
                value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
                onChange={(v,dateString)=> handleDateChange(v,dateString)}
          />
         <Button style={{ marginLeft: "2rem", backgroundColor: "rgb(103, 58, 183)",color: 'white',padding: "0 2rem 0 2rem" }} type='dashed' onClick={()=> showConfirm()} >
          Pay
        </Button>
        </div>
        <div style={{display: 'flex',flexDirection: 'column'}}>
            <h1 style={{margin: "0 0 1rem 1rem",color: "#673ab7",textAlign: 'end'}}>{totalAmount}</h1>
            <h4 style={{margin: "0 0 0 1rem",fontWeight: 'normal',textAlign: 'end'}}>Total Commission</h4>
          </div>
        
       </div>
      <Table loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={commissions} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={total} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}

